import React from "react";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import MainFrameContainer from "./MainFrameContainer";
import Button from "material-ui/Button";
import { withRouter } from "react-router-dom";

const styles = theme => ({
  root: {
    display: "flex",
    flexDirection: "column",

    alignItems: "center"
  },
  button: {
    marginTop: 50
  }
});

const NoMatch = props => {
  const { classes, location, history } = props;

  const navigateBack = () => {
    history.goBack();
  };

  return (
    <MainFrameContainer
      isError
      appBarHeight={128}
      body={
        <div className={classes.root}>
          <Typography type="display3" gutterBottom align="center">
            Oops!
          </Typography>

          <Typography type="display1" gutterBottom align="center">
            No valid resource exists at this URL
          </Typography>

          <Typography type="display1" gutterBottom align="center">
            <pre>{location.pathname} </pre>
          </Typography>
          <Button
            className={classes.button}
            raised
            color="accent"
            onClick={navigateBack}
          >
            Go back
          </Button>
        </div>
      }
    />
  );
};

export { NoMatch };

export default withStyles(styles, { name: "NoMatch" })(withRouter(NoMatch));



// WEBPACK FOOTER //
// ./src/NoMatch.js